import { extend } from 'lodash';
import { RequestOptions, RequestPromise } from './types';
import { Request } from './requset';
import { requestLogger, responseLogger, errorLogger } from './interceptor/logger';
import nextCSRF from './interceptor/next_csrf';
import nextAuth from './interceptor/next_auth';
import requsetSdkQuery from './interceptor/sdk-query';
import responseError from './interceptor/error';
// eslint-disable-next-line import/no-cycle
import { requestCSRF, responseCSRF } from './interceptor/csrf';

export type { RequestOptions, RequestError, RequestPromise, RequestResponse } from './types';

export { Request };

export interface RequestInstance extends Request {
  <T = any>(opts: RequestOptions): RequestPromise<T>;
}

/**
 * @description 创建请求实例
 * @param {RequestOptions} opts
 */
export function createInstance(opts: RequestOptions) {
  const instance = new Request(opts);

  const request = Request.prototype.request.bind(instance);

  extend(request, instance);

  request.get = instance.get.bind(instance);
  request.post = instance.post.bind(instance);

  return request as RequestInstance;
}

const request = createInstance({});

const isProd = process.env.NODE_ENV === 'production';

request.interceptors.request.use(requsetSdkQuery);

// csrf 拦截器
request.interceptors.request.use(requestCSRF);
request.interceptors.response.use(responseCSRF);
request.interceptors.request.use(nextCSRF);

// next auth不过跳登陆页
request.interceptors.response.use(nextAuth);

// logger 拦截器
request.interceptors.request.use((options) => {
  if (isProd) return options;
  return requestLogger(options);
}, errorLogger);
request.interceptors.response.use((response) => {
  if (isProd) return response;
  return responseLogger(response);
}, errorLogger);

request.interceptors.response.use((response) => response, responseError);

export default request;
